import { MutationTree } from 'vuex'
import { SwatchesState } from './swatches.types'

export enum MutationTypes {
  SET_ALL_SWATCHES = 'SET_ALL_SWATCHES',
  SET_SWATCHES_LOADING_ERROR = 'SET_SWATCHES_LOADING_ERROR'
}

export const mutations: MutationTree<SwatchesState> = {
  [MutationTypes.SET_ALL_SWATCHES](state, swatches) {
    state.swatches = swatches
  },
  [MutationTypes.SET_SWATCHES_LOADING_ERROR](state, error) {
    state.swatchesLoadingError = error
  }
}
